<template>
  <el-dialog title="报警消息"
    :visible.sync="showList"
    :modal="false"
    :before-close="close"
    width="300px"
    append-to-body
    :close-on-click-modal="true">
      <el-scrollbar class="wrap" :style="{'height': (list && list.length) < 3 ? 83 * (list && list.length) + 'px' : '249px'}">
        <div class="flex" v-for="item in list" >
          <div class="item">
            <div>{{item.startTs}}</div>
            <div>{{item.warnName || ''}}</div>
          </div>
          <el-button @click="goDetail(item.id)">查看详情</el-button>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer"></span>
  </el-dialog>
</template>

<script>
export default {
  props:['showList', 'list'],
  data() {
    return {
    }
  },
  created() {
    this.$nextTick(() => {

    })
  },
  methods: {
    goDetail(warnConfigId){
      this.close()
      this.$router.push({path: '/plugin/serviceAlarm/UI/ElaryWarningInfoList', query: { warnConfigId }})
    },
    close(){
      this.$emit('closeDialog',{})
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-dialog {
    position: absolute;
    right: 20px;
    top: 50px;
    margin-top: 3vh !important;
    left: unset;
    line-height: initial;
    transform:none;
    box-shadow: none;
  }
  ::v-deep .el-dialog__header {
    padding-top: 14px;
  }
  ::v-deep .el-dialog__title {
    text-align: left;
  }
  ::v-deep .el-dialog__body {
    margin: 0 20px 20px 20px;
    padding: 0;
    overflow: auto; 
    color: #fff;
  } 
  .flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #999;
    padding: 5px 10px;
    margin: 15px 0;
  }
  .flex:first-child{
    margin-top: 0;
  }
  .flex:last-child{
    margin-bottom: 0;
  }
  .item{
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    div{
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100px;
    }
  }
  ::v-deep .el-scrollbar{
    width: 100%;
  }
  ::v-deep .el-scrollbar__wrap{
    overflow-x: hidden !important;
  }
  ::v-deep .el-dialog__footer{
    padding: 0 !important;
  }
  .blue{
    color: #3affff;
  }
  .red{
     color: #f73e3e;
  }  
  .orange{
     color: #f09d18;
  }
  .yellow{
    color: #fefc36;
  }
</style>
